//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
var ApiClientBase = /** @class */ (function () {
    function ApiClientBase(config) {
        var _this = this;
        this.transformOptions = function (options) {
            options.headers = __assign(__assign({}, options.headers), { Authorization: _this.config.getAuthorization() });
            // See https://developer.mozilla.org/en-US/docs/Web/API/fetch#parameters
            // We want the cookies to be sent with request (as long as the target domain matches) - VendorId cookie
            options.credentials = 'include';
            return Promise.resolve(options);
        };
        this.config = config;
    }
    return ApiClientBase;
}());
export { ApiClientBase };
var BidClient = /** @class */ (function (_super) {
    __extends(BidClient, _super);
    function BidClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    BidClient.prototype.getById = function (id, fetchRemedyInstanceIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Bid/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fetchRemedyInstanceIds === null)
            throw new Error("The parameter 'fetchRemedyInstanceIds' cannot be null.");
        else if (fetchRemedyInstanceIds !== undefined)
            url_ += "fetchRemedyInstanceIds=" + encodeURIComponent("" + fetchRemedyInstanceIds) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetById(_response);
        });
    };
    BidClient.prototype.processGetById = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    BidClient.prototype.deleteBid = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Bid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processDeleteBid(_response);
        });
    };
    BidClient.prototype.processDeleteBid = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    BidClient.prototype.search = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Bid/Search";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processSearch(_response);
        });
    };
    BidClient.prototype.processSearch = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    BidClient.prototype.createBid = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Bid";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processCreateBid(_response);
        });
    };
    BidClient.prototype.processCreateBid = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    BidClient.prototype.updateBid = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Bid";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUpdateBid(_response);
        });
    };
    BidClient.prototype.processUpdateBid = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    BidClient.prototype.evaluateStateMachine = function (id, actionName, actionParameters) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Bid/{id}/Evaluate/{actionName}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (actionName === undefined || actionName === null)
            throw new Error("The parameter 'actionName' must be defined.");
        url_ = url_.replace("{actionName}", encodeURIComponent("" + actionName));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(actionParameters);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processEvaluateStateMachine(_response);
        });
    };
    BidClient.prototype.processEvaluateStateMachine = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    BidClient.prototype.createBidOption = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Bid/Option";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processCreateBidOption(_response);
        });
    };
    BidClient.prototype.processCreateBidOption = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    BidClient.prototype.updateBidOption = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Bid/Option";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUpdateBidOption(_response);
        });
    };
    BidClient.prototype.processUpdateBidOption = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    BidClient.prototype.deleteBidOption = function (id, optionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Bid/{id}/Option/{optionId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (optionId === undefined || optionId === null)
            throw new Error("The parameter 'optionId' must be defined.");
        url_ = url_.replace("{optionId}", encodeURIComponent("" + optionId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processDeleteBidOption(_response);
        });
    };
    BidClient.prototype.processDeleteBidOption = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return BidClient;
}(ApiClientBase));
export { BidClient };
var CommandClient = /** @class */ (function (_super) {
    __extends(CommandClient, _super);
    function CommandClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    CommandClient.prototype.submitOrderCommand = function (orderId, commandId, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Command/order/{orderId}/command/{commandId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processSubmitOrderCommand(_response);
        });
    };
    CommandClient.prototype.processSubmitOrderCommand = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    CommandClient.prototype.submitOrderFileCommand = function (orderId, commandId, fileId, file, timestamp) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Command/order/{orderId}/command/{commandId}/{fileId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (timestamp === null || timestamp === undefined)
            throw new Error("The parameter 'timestamp' cannot be null.");
        else
            content_.append("Timestamp", timestamp.toString());
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processSubmitOrderFileCommand(_response);
        });
    };
    CommandClient.prototype.processSubmitOrderFileCommand = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    CommandClient.prototype.test = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Command/test";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processTest(_response);
        });
    };
    CommandClient.prototype.processTest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return CommandClient;
}(ApiClientBase));
export { CommandClient };
var ConditionIssueInstanceClient = /** @class */ (function (_super) {
    __extends(ConditionIssueInstanceClient, _super);
    function ConditionIssueInstanceClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    ConditionIssueInstanceClient.prototype.createConditionIssueInstance = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/ConditionIssueInstance";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processCreateConditionIssueInstance(_response);
        });
    };
    ConditionIssueInstanceClient.prototype.processCreateConditionIssueInstance = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ConditionIssueInstanceClient.prototype.deleteConditionIssueInstance = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/ConditionIssueInstance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processDeleteConditionIssueInstance(_response);
        });
    };
    ConditionIssueInstanceClient.prototype.processDeleteConditionIssueInstance = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ConditionIssueInstanceClient.prototype.updateConditionIssueInstanceStatus = function (id, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/ConditionIssueInstance/{id}/Status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUpdateConditionIssueInstanceStatus(_response);
        });
    };
    ConditionIssueInstanceClient.prototype.processUpdateConditionIssueInstanceStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ConditionIssueInstanceClient.prototype.escalateConditionIssueInstance = function (id, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/ConditionIssueInstance/{id}/Escalate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processEscalateConditionIssueInstance(_response);
        });
    };
    ConditionIssueInstanceClient.prototype.processEscalateConditionIssueInstance = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ConditionIssueInstanceClient.prototype.evaluateStateMachine = function (id, actionName, actionParameters) {
        var _this = this;
        var url_ = this.baseUrl + "/api/ConditionIssueInstance/{id}/Evaluate/{actionName}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (actionName === undefined || actionName === null)
            throw new Error("The parameter 'actionName' must be defined.");
        url_ = url_.replace("{actionName}", encodeURIComponent("" + actionName));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(actionParameters);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processEvaluateStateMachine(_response);
        });
    };
    ConditionIssueInstanceClient.prototype.processEvaluateStateMachine = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return ConditionIssueInstanceClient;
}(ApiClientBase));
export { ConditionIssueInstanceClient };
var EmployeeClient = /** @class */ (function (_super) {
    __extends(EmployeeClient, _super);
    function EmployeeClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    EmployeeClient.prototype.getEmployeesWithRole = function (roleId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Employee?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetEmployeesWithRole(_response);
        });
    };
    EmployeeClient.prototype.processGetEmployeesWithRole = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return EmployeeClient;
}(ApiClientBase));
export { EmployeeClient };
var FileClient = /** @class */ (function (_super) {
    __extends(FileClient, _super);
    function FileClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    FileClient.prototype.createFile = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/File";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processCreateFile(_response);
        });
    };
    FileClient.prototype.processCreateFile = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    FileClient.prototype.getTypedAttributes = function (attributes) {
        var _this = this;
        var url_ = this.baseUrl + "/api/File?";
        if (attributes !== undefined && attributes !== null)
            url_ += "attributes=" + encodeURIComponent("" + attributes) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetTypedAttributes(_response);
        });
    };
    FileClient.prototype.processGetTypedAttributes = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    FileClient.prototype.uploadFile = function (fileId, file, attributes) {
        var _this = this;
        var url_ = this.baseUrl + "/api/File";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (fileId === null || fileId === undefined)
            throw new Error("The parameter 'fileId' cannot be null.");
        else
            content_.append("FileId", fileId.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (attributes !== null && attributes !== undefined)
            content_.append("Attributes", attributes.toString());
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUploadFile(_response);
        });
    };
    FileClient.prototype.processUploadFile = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    FileClient.prototype.uploadFileContent = function (id, file) {
        var _this = this;
        var url_ = this.baseUrl + "/api/File/{id}/Content";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUploadFileContent(_response);
        });
    };
    FileClient.prototype.processUploadFileContent = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    FileClient.prototype.deleteFile = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/File/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processDeleteFile(_response);
        });
    };
    FileClient.prototype.processDeleteFile = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    FileClient.prototype.getConditionIssueInstanceFiles = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/File/ConditionIssueInstance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetConditionIssueInstanceFiles(_response);
        });
    };
    FileClient.prototype.processGetConditionIssueInstanceFiles = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    FileClient.prototype.getVendorTermsAndConditionsFileUrl = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/File/GetVendorTermsAndConditionsFileUrl";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetVendorTermsAndConditionsFileUrl(_response);
        });
    };
    FileClient.prototype.processGetVendorTermsAndConditionsFileUrl = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return FileClient;
}(ApiClientBase));
export { FileClient };
var GeotabClient = /** @class */ (function (_super) {
    __extends(GeotabClient, _super);
    function GeotabClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    GeotabClient.prototype.geotabDevices = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geotab/Devices";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGeotabDevices(_response);
        });
    };
    GeotabClient.prototype.processGeotabDevices = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    GeotabClient.prototype.updateResourceDeviceRelation = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geotab/Device";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUpdateResourceDeviceRelation(_response);
        });
    };
    GeotabClient.prototype.processUpdateResourceDeviceRelation = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return GeotabClient;
}(ApiClientBase));
export { GeotabClient };
var InventoryClient = /** @class */ (function (_super) {
    __extends(InventoryClient, _super);
    function InventoryClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    InventoryClient.prototype.userAvailableInventory = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Inventory/UserAvailableInventory";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUserAvailableInventory(_response);
        });
    };
    InventoryClient.prototype.processUserAvailableInventory = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    InventoryClient.prototype.locations = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Inventory/Locations";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processLocations(_response);
        });
    };
    InventoryClient.prototype.processLocations = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    InventoryClient.prototype.transactions = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Inventory/Transactions";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processTransactions(_response);
        });
    };
    InventoryClient.prototype.processTransactions = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    InventoryClient.prototype.order = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Inventory/Order/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processOrder(_response);
        });
    };
    InventoryClient.prototype.processOrder = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    InventoryClient.prototype.issueInventory = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Inventory/IssueInventory";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processIssueInventory(_response);
        });
    };
    InventoryClient.prototype.processIssueInventory = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    InventoryClient.prototype.receiveInventory = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Inventory/ReceiveInventory";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processReceiveInventory(_response);
        });
    };
    InventoryClient.prototype.processReceiveInventory = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return InventoryClient;
}(ApiClientBase));
export { InventoryClient };
var LocationClient = /** @class */ (function (_super) {
    __extends(LocationClient, _super);
    function LocationClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    LocationClient.prototype.createLocation = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Location";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processCreateLocation(_response);
        });
    };
    LocationClient.prototype.processCreateLocation = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    LocationClient.prototype.updateLocation = function (id, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Location/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUpdateLocation(_response);
        });
    };
    LocationClient.prototype.processUpdateLocation = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    LocationClient.prototype.deleteLocation = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Location/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processDeleteLocation(_response);
        });
    };
    LocationClient.prototype.processDeleteLocation = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    LocationClient.prototype.getLocationById = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Location/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetLocationById(_response);
        });
    };
    LocationClient.prototype.processGetLocationById = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    LocationClient.prototype.searchLocations = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Location/Search";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processSearchLocations(_response);
        });
    };
    LocationClient.prototype.processSearchLocations = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return LocationClient;
}(ApiClientBase));
export { LocationClient };
var LockboxClient = /** @class */ (function (_super) {
    __extends(LockboxClient, _super);
    function LockboxClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    LockboxClient.prototype.accessCode = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Lockbox/AccessCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processAccessCode(_response);
        });
    };
    LockboxClient.prototype.processAccessCode = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    LockboxClient.prototype.search = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Lockbox/Search";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processSearch(_response);
        });
    };
    LockboxClient.prototype.processSearch = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    LockboxClient.prototype.installLockbox = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Lockbox/Install";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processInstallLockbox(_response);
        });
    };
    LockboxClient.prototype.processInstallLockbox = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    LockboxClient.prototype.uninstallLockbox = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Lockbox/Uninstall";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUninstallLockbox(_response);
        });
    };
    LockboxClient.prototype.processUninstallLockbox = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return LockboxClient;
}(ApiClientBase));
export { LockboxClient };
var LogClient = /** @class */ (function (_super) {
    __extends(LogClient, _super);
    function LogClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    LogClient.prototype.addLog = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Log";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processAddLog(_response);
        });
    };
    LogClient.prototype.processAddLog = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return LogClient;
}(ApiClientBase));
export { LogClient };
var NotificationClient = /** @class */ (function (_super) {
    __extends(NotificationClient, _super);
    function NotificationClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    NotificationClient.prototype.get = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Notification";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    NotificationClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    NotificationClient.prototype.pin = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Notification/Pin/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processPin(_response);
        });
    };
    NotificationClient.prototype.processPin = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    NotificationClient.prototype.unpin = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Notification/Pin/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUnpin(_response);
        });
    };
    NotificationClient.prototype.processUnpin = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return NotificationClient;
}(ApiClientBase));
export { NotificationClient };
var OrderClient = /** @class */ (function (_super) {
    __extends(OrderClient, _super);
    function OrderClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    OrderClient.prototype.query = function (today, loadFiles) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/Query?";
        if (today === null)
            throw new Error("The parameter 'today' cannot be null.");
        else if (today !== undefined)
            url_ += "today=" + encodeURIComponent("" + today) + "&";
        if (loadFiles === null)
            throw new Error("The parameter 'loadFiles' cannot be null.");
        else if (loadFiles !== undefined)
            url_ += "loadFiles=" + encodeURIComponent("" + loadFiles) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processQuery(_response);
        });
    };
    OrderClient.prototype.processQuery = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.queryOrderFiles = function (today) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/Query/Files?";
        if (today === null)
            throw new Error("The parameter 'today' cannot be null.");
        else if (today !== undefined)
            url_ += "today=" + encodeURIComponent("" + today) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processQueryOrderFiles(_response);
        });
    };
    OrderClient.prototype.processQueryOrderFiles = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.findById = function (orderId, today) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/{orderId}?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (today === null)
            throw new Error("The parameter 'today' cannot be null.");
        else if (today !== undefined)
            url_ += "today=" + encodeURIComponent("" + today) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processFindById(_response);
        });
    };
    OrderClient.prototype.processFindById = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.search = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/Search";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processSearch(_response);
        });
    };
    OrderClient.prototype.processSearch = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.getVendorAdminOrders = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/VendorAdminOrders";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetVendorAdminOrders(_response);
        });
    };
    OrderClient.prototype.processGetVendorAdminOrders = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.getVendorTechnicianOrders = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/VendorTechnicianOrders";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetVendorTechnicianOrders(_response);
        });
    };
    OrderClient.prototype.processGetVendorTechnicianOrders = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.mutateState = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/MutateState";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processMutateState(_response);
        });
    };
    OrderClient.prototype.processMutateState = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.reviewSubmit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/{id}/Scope/ReviewSubmit";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processReviewSubmit(_response);
        });
    };
    OrderClient.prototype.processReviewSubmit = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.setInspected = function (id, targetId, inspected) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/{id}/SetInspected/{targetId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (targetId === undefined || targetId === null)
            throw new Error("The parameter 'targetId' must be defined.");
        url_ = url_.replace("{targetId}", encodeURIComponent("" + targetId));
        if (inspected === null)
            throw new Error("The parameter 'inspected' cannot be null.");
        else if (inspected !== undefined)
            url_ += "inspected=" + encodeURIComponent("" + inspected) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PATCH",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processSetInspected(_response);
        });
    };
    OrderClient.prototype.processSetInspected = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @deprecated
     */
    OrderClient.prototype.addServiceTasks = function (id, serviceTaskModels) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/{id}/AddServiceTasks";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(serviceTaskModels);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processAddServiceTasks(_response);
        });
    };
    OrderClient.prototype.processAddServiceTasks = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.addServiceTask = function (id, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/{id}/ServiceTask";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processAddServiceTask(_response);
        });
    };
    OrderClient.prototype.processAddServiceTask = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.updateServiceTask = function (id, serviceTaskId, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/{id}/ServiceTask/{serviceTaskId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (serviceTaskId === undefined || serviceTaskId === null)
            throw new Error("The parameter 'serviceTaskId' must be defined.");
        url_ = url_.replace("{serviceTaskId}", encodeURIComponent("" + serviceTaskId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUpdateServiceTask(_response);
        });
    };
    OrderClient.prototype.processUpdateServiceTask = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.addNote = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/Notes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processAddNote(_response);
        });
    };
    OrderClient.prototype.processAddNote = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.updateNote = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/Notes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUpdateNote(_response);
        });
    };
    OrderClient.prototype.processUpdateNote = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.updateNoteStatus = function (id, isRead) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/NoteStatus/{id}/{isRead}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isRead === undefined || isRead === null)
            throw new Error("The parameter 'isRead' must be defined.");
        url_ = url_.replace("{isRead}", encodeURIComponent("" + isRead));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUpdateNoteStatus(_response);
        });
    };
    OrderClient.prototype.processUpdateNoteStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.batchUpdateNoteStatus = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/Batch/UpdateNoteStatus";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processBatchUpdateNoteStatus(_response);
        });
    };
    OrderClient.prototype.processBatchUpdateNoteStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.evaluateStateMachine = function (orderId, actionName, actionParameters) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/{orderId}/Evaluate/{actionName}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (actionName === undefined || actionName === null)
            throw new Error("The parameter 'actionName' must be defined.");
        url_ = url_.replace("{actionName}", encodeURIComponent("" + actionName));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(actionParameters);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processEvaluateStateMachine(_response);
        });
    };
    OrderClient.prototype.processEvaluateStateMachine = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    OrderClient.prototype.evaluateServiceTaskStatus = function (orderId, serviceTaskId, actionName, actionParameters) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/{orderId}/ServiceTask/{serviceTaskId}/Evaluate/{actionName}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (serviceTaskId === undefined || serviceTaskId === null)
            throw new Error("The parameter 'serviceTaskId' must be defined.");
        url_ = url_.replace("{serviceTaskId}", encodeURIComponent("" + serviceTaskId));
        if (actionName === undefined || actionName === null)
            throw new Error("The parameter 'actionName' must be defined.");
        url_ = url_.replace("{actionName}", encodeURIComponent("" + actionName));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(actionParameters);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processEvaluateServiceTaskStatus(_response);
        });
    };
    OrderClient.prototype.processEvaluateServiceTaskStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return OrderClient;
}(ApiClientBase));
export { OrderClient };
var PropertyClient = /** @class */ (function (_super) {
    __extends(PropertyClient, _super);
    function PropertyClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    PropertyClient.prototype.setCoordinates = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Property/SetCoordinates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processSetCoordinates(_response);
        });
    };
    PropertyClient.prototype.processSetCoordinates = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PropertyClient.prototype.getHistory = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Property/{id}/History";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetHistory(_response);
        });
    };
    PropertyClient.prototype.processGetHistory = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return PropertyClient;
}(ApiClientBase));
export { PropertyClient };
var ReferenceClient = /** @class */ (function (_super) {
    __extends(ReferenceClient, _super);
    function ReferenceClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    ReferenceClient.prototype.getGlobalData = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Reference/Global";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetGlobalData(_response);
        });
    };
    ReferenceClient.prototype.processGetGlobalData = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ReferenceClient.prototype.getUserData = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Reference/User";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetUserData(_response);
        });
    };
    ReferenceClient.prototype.processGetUserData = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return ReferenceClient;
}(ApiClientBase));
export { ReferenceClient };
var RemedyClient = /** @class */ (function (_super) {
    __extends(RemedyClient, _super);
    function RemedyClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    /**
     * @deprecated
     */
    RemedyClient.prototype.getRemedies = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Remedy";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetRemedies(_response);
        });
    };
    RemedyClient.prototype.processGetRemedies = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return RemedyClient;
}(ApiClientBase));
export { RemedyClient };
var RemedyInstanceClient = /** @class */ (function (_super) {
    __extends(RemedyInstanceClient, _super);
    function RemedyInstanceClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    RemedyInstanceClient.prototype.createRemedyInstance = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/RemedyInstance";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processCreateRemedyInstance(_response);
        });
    };
    RemedyInstanceClient.prototype.processCreateRemedyInstance = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    RemedyInstanceClient.prototype.updateRemedyInstance = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/RemedyInstance";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUpdateRemedyInstance(_response);
        });
    };
    RemedyInstanceClient.prototype.processUpdateRemedyInstance = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    RemedyInstanceClient.prototype.updateRemedyInstanceAssignment = function (id, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/RemedyInstance/{id}/Assignment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUpdateRemedyInstanceAssignment(_response);
        });
    };
    RemedyInstanceClient.prototype.processUpdateRemedyInstanceAssignment = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    RemedyInstanceClient.prototype.updateRemedyInstanceAssignments = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/RemedyInstance/Assignment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUpdateRemedyInstanceAssignments(_response);
        });
    };
    RemedyInstanceClient.prototype.processUpdateRemedyInstanceAssignments = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    RemedyInstanceClient.prototype.updateRemedyInstanceService = function (id, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/RemedyInstance/{id}/Service";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUpdateRemedyInstanceService(_response);
        });
    };
    RemedyInstanceClient.prototype.processUpdateRemedyInstanceService = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    RemedyInstanceClient.prototype.deleteRemedyInstance = function (id, orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/RemedyInstance/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processDeleteRemedyInstance(_response);
        });
    };
    RemedyInstanceClient.prototype.processDeleteRemedyInstance = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return RemedyInstanceClient;
}(ApiClientBase));
export { RemedyInstanceClient };
var ResourceClient = /** @class */ (function (_super) {
    __extends(ResourceClient, _super);
    function ResourceClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    ResourceClient.prototype.getResourcesForCurrentVendor = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resource/CurrentVendor";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetResourcesForCurrentVendor(_response);
        });
    };
    ResourceClient.prototype.processGetResourcesForCurrentVendor = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return ResourceClient;
}(ApiClientBase));
export { ResourceClient };
var ReviewClient = /** @class */ (function (_super) {
    __extends(ReviewClient, _super);
    function ReviewClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    ReviewClient.prototype.getInspection = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Review/Inspection/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetInspection(_response);
        });
    };
    ReviewClient.prototype.processGetInspection = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ReviewClient.prototype.createReview = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Review";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processCreateReview(_response);
        });
    };
    ReviewClient.prototype.processCreateReview = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ReviewClient.prototype.searchReviews = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Review/Search";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processSearchReviews(_response);
        });
    };
    ReviewClient.prototype.processSearchReviews = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ReviewClient.prototype.approveReview = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Review/{id}/Approve";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processApproveReview(_response);
        });
    };
    ReviewClient.prototype.processApproveReview = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ReviewClient.prototype.rejectReview = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Review/{id}/Reject";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processRejectReview(_response);
        });
    };
    ReviewClient.prototype.processRejectReview = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return ReviewClient;
}(ApiClientBase));
export { ReviewClient };
var SandboxClient = /** @class */ (function (_super) {
    __extends(SandboxClient, _super);
    function SandboxClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    SandboxClient.prototype.purgeCache = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Sandbox/PurgeCache";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processPurgeCache(_response);
        });
    };
    SandboxClient.prototype.processPurgeCache = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return SandboxClient;
}(ApiClientBase));
export { SandboxClient };
var TimeCardClient = /** @class */ (function (_super) {
    __extends(TimeCardClient, _super);
    function TimeCardClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    TimeCardClient.prototype.getForEmployee = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/TimeCard/GetForEmployee";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetForEmployee(_response);
        });
    };
    TimeCardClient.prototype.processGetForEmployee = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    TimeCardClient.prototype.clockIn = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/TimeCard/ClockIn";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processClockIn(_response);
        });
    };
    TimeCardClient.prototype.processClockIn = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    TimeCardClient.prototype.clockOut = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/TimeCard/ClockOut";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processClockOut(_response);
        });
    };
    TimeCardClient.prototype.processClockOut = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return TimeCardClient;
}(ApiClientBase));
export { TimeCardClient };
var UmbracoContentClient = /** @class */ (function (_super) {
    __extends(UmbracoContentClient, _super);
    function UmbracoContentClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    UmbracoContentClient.prototype.getVendorOfficeInfo = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/UmbracoContent/VendorOfficeInfo";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetVendorOfficeInfo(_response);
        });
    };
    UmbracoContentClient.prototype.processGetVendorOfficeInfo = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return UmbracoContentClient;
}(ApiClientBase));
export { UmbracoContentClient };
var UserClient = /** @class */ (function (_super) {
    __extends(UserClient, _super);
    function UserClient(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/services-api";
        return _this;
    }
    UserClient.prototype.getCurrent = function (vendorId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/CurrentUser?";
        if (vendorId !== undefined && vendorId !== null)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGetCurrent(_response);
        });
    };
    UserClient.prototype.processGetCurrent = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    UserClient.prototype.updateCurrentGeoCoordinates = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/CurrentUser/CurrentGeoCoordinates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processUpdateCurrentGeoCoordinates(_response);
        });
    };
    UserClient.prototype.processUpdateCurrentGeoCoordinates = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                var result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                result500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return UserClient;
}(ApiClientBase));
export { UserClient };
export var EscalationType;
(function (EscalationType) {
    EscalationType[EscalationType["Manager"] = 1] = "Manager";
    EscalationType[EscalationType["ThirdParty"] = 2] = "ThirdParty";
})(EscalationType || (EscalationType = {}));
export var TransactionType;
(function (TransactionType) {
    TransactionType[TransactionType["None"] = 0] = "None";
    TransactionType[TransactionType["IssueInventory"] = 1] = "IssueInventory";
    TransactionType[TransactionType["ReceiveInventory"] = 2] = "ReceiveInventory";
    TransactionType[TransactionType["TransferInventory"] = 3] = "TransferInventory";
    TransactionType[TransactionType["AdjustInventory"] = 4] = "AdjustInventory";
})(TransactionType || (TransactionType = {}));
export var AccessType;
(function (AccessType) {
    AccessType[AccessType["Customer"] = 0] = "Customer";
    AccessType[AccessType["Vendor"] = 1] = "Vendor";
    AccessType[AccessType["User"] = 2] = "User";
})(AccessType || (AccessType = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["Sunday"] = 0] = "Sunday";
    DayOfWeek[DayOfWeek["Monday"] = 1] = "Monday";
    DayOfWeek[DayOfWeek["Tuesday"] = 2] = "Tuesday";
    DayOfWeek[DayOfWeek["Wednesday"] = 3] = "Wednesday";
    DayOfWeek[DayOfWeek["Thursday"] = 4] = "Thursday";
    DayOfWeek[DayOfWeek["Friday"] = 5] = "Friday";
    DayOfWeek[DayOfWeek["Saturday"] = 6] = "Saturday";
})(DayOfWeek || (DayOfWeek = {}));
export var VendorAdminOrderType;
(function (VendorAdminOrderType) {
    VendorAdminOrderType["ReadyForAcceptance"] = "ReadyForAcceptance";
    VendorAdminOrderType["Accepted"] = "Accepted";
})(VendorAdminOrderType || (VendorAdminOrderType = {}));
export var ReferenceItemType;
(function (ReferenceItemType) {
    ReferenceItemType["Location"] = "Location";
    ReferenceItemType["Asset"] = "Asset";
    ReferenceItemType["ConditionIssue"] = "ConditionIssue";
    ReferenceItemType["Remedy"] = "Remedy";
    ReferenceItemType["MeasureUnit"] = "MeasureUnit";
})(ReferenceItemType || (ReferenceItemType = {}));
export var AttributeValueType;
(function (AttributeValueType) {
    AttributeValueType["None"] = "None";
    AttributeValueType["String"] = "String";
    AttributeValueType["Int"] = "Int";
    AttributeValueType["Bool"] = "Bool";
    AttributeValueType["Decimal"] = "Decimal";
    AttributeValueType["Date"] = "Date";
    AttributeValueType["DateTime"] = "DateTime";
    AttributeValueType["Taxonomy"] = "Taxonomy";
})(AttributeValueType || (AttributeValueType = {}));
export var EscalationType2;
(function (EscalationType2) {
    EscalationType2[EscalationType2["Manager"] = 1] = "Manager";
    EscalationType2[EscalationType2["ThirdParty"] = 2] = "ThirdParty";
})(EscalationType2 || (EscalationType2 = {}));
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
export { ApiException };
function throwException(message, status, response, headers, result) {
    throw new ApiException(message, status, response, headers, result);
}
